const $photosWidget = $('[data-js-photos-widget]');
const $photosWidgetContent = $('[data-js-photos-widget-content]');

window.RR.photosCallback = (content) => {
  $photosWidget.show();
  $photosWidgetContent.html(content);
};
